module.exports = __webpack_public_path__ + "static/media/subscription-active.738e3b86.svg";